/* eslint-disable max-classes-per-file */
/* eslint-disable no-console */
/**
 * Footer container selector
 * @const {string}
 */
const FOOTER_CONTAINER_SELECTOR = '[data-component="footer-container"]';

/**
 * Footer content section toggle control
 * @const {string}
 */
const FOOTER_CONTENT_SECTION_TOGGLE =
    '[data-click="footer-content-toggle-section"]';

/**
 * Footer content sub section toggle control
 * @const {string}
 */
const FOOTER_CONTENT_SECTION_SUB_SECTION_TOGGLE =
    '[data-click="footer-content-toggle-section__sub-section"]';

/**
 * Footer content section active/open class
 * @const {string}
 */
const FOOTER_CONTENT_SECTION_ACTIVE =
    'footer__col-content-section__button--active';

/**
 * Footer content section list active/open class
 * @const {string}
 */
const FOOTER_LIST_ACTIVE = 'footer__list--active';

class FooterContainerImpl {
    constructor(footerContainer) {
        this.footerContainer = footerContainer;

        // Attach on item click handler
        const sectionToggles = footerContainer.querySelectorAll(
            FOOTER_CONTENT_SECTION_TOGGLE
        );
        sectionToggles.forEach((sectionToggle) => {
            sectionToggle.addEventListener('click', () => {
                this._handleToggleSection(sectionToggle);
            });
        });

        const subSectionToggles = footerContainer.querySelectorAll(
            FOOTER_CONTENT_SECTION_SUB_SECTION_TOGGLE
        );
        subSectionToggles.forEach((subSectionToggle) => {
            subSectionToggle.addEventListener('click', () => {
                this._handleToggleSection(subSectionToggle);
            });
        });
    }

    /**
     * Event handler for sub menu item click
     * @param {HTMLElement} section - The sub menu item DOM Element
     */
    _handleToggleSection(sectionToggle) {
        const sectionList = document.getElementById(
            sectionToggle.getAttribute('aria-controls')
        );

        if (sectionToggle.getAttribute('aria-expanded') === 'false') {
            sectionToggle.setAttribute('aria-expanded', true);
            this._transitionItemSectionOpen(sectionToggle, sectionList);
        } else {
            sectionToggle.setAttribute('aria-expanded', false);
            this._transitionItemSectionClosed(sectionToggle, sectionList);
        }
    }

    // Transition handlers

    _transitionItemSectionOpen(sectionToggle, sectionList) {
        sectionToggle.classList.add(FOOTER_CONTENT_SECTION_ACTIVE);
        sectionList.classList.add(FOOTER_LIST_ACTIVE);
    }

    _transitionItemSectionClosed(sectionToggle, sectionList) {
        sectionToggle.classList.remove(FOOTER_CONTENT_SECTION_ACTIVE);
        sectionList.classList.remove(FOOTER_LIST_ACTIVE);
    }
}

/**
 * Singelton wrapper for hamburger menu to give other areas of the template
 * access to the menu without having to pull it from the DOM directly.
 */
export default class FooterContainer {
    /**
     * Access method to get a hold of the template hamburger menu
     * @returns {FooterContainerHamburgerMenuImpl} - Hamburger menu object
     */
    static getInstance() {
        const footerContainer = document.querySelector(
            FOOTER_CONTAINER_SELECTOR
        );
        // Hamburger doesnt exist, return null
        if (!footerContainer) {
            return null;
        }

        // Doesnt exist yet, create new menu object
        if (!footerContainer._footerContainer) {
            // Store the actual class against the DOM, as if this is destroyed for any reason it will need to be re-instantiated
            footerContainer._footerContainer = new FooterContainerImpl(
                footerContainer
            );
        }

        // Return existing menu object
        return footerContainer._footerContainer;
    }
}

// Bootstrap the hamburger menu
FooterContainer.getInstance();
